import "./modalAir.css"
import React, { useContext, useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom";
import { auth, db } from "../../../../config/firebaseConfig"; // Firebase設定
import { serverTimestamp, where, updateDoc, collection, getDocs, getDoc, orderBy, addDoc, query, doc } from "firebase/firestore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { logChange } from "../../../../utils/logService";



const ModalAir = ({isOpen, onClose, mode, selectedData})=>{
    const navigate = useNavigate();
    const { masterID } = useParams(); // URLのパラメータを取得 (id)
    const [airName, setAirName] = useState();
    const [airType, setAirType] = useState();
    const [uttID, setUttID] = useState();
    const [capacityA, setCapacityA] = useState();
    const [updatedkva, setUpdatedKVA] = useState();
    const [capacityKVA, setCapacityKVA] = useState();
    const [electircSize, setAirSize] = useState();
    const [remark1, setRemark1] = useState();
    const [selectedProjectId, setselectedProjectId] = useState();
    const [currentUser, setCurrentUser] = useState();
    const [createdAt, setCreatedAt]= useState(()=>{
        return mode==="edit"&& selectedData?.createdAt
        ? selectedData.createdAt //既存データアリの場合はそのまま
        : new Date().toISOString();//新規作成時は現在日時
    });
    const [updatedAt, setUpdatedAt] = useState();
    const [formData, setFormData] = useState({
    });
    const [options, setOptions] = useState();

    //編集の場合はformの初期値を表の選択行の値を設置するコード
    const currentProjectID = localStorage.getItem("currentProjectID");
    useEffect(()=>{
        if(mode ==='edit'&& selectedData){
            // console.log('selectedData kva', selectedData.capacityKVA)
            const updatedFormData={
            // setFormData({
                masterID: selectedData.masterID,
                uttID: selectedData.uttID?? null,
                capacity: selectedData.capacity ?? null,
                connectionSize: selectedData.connectionSize ?? '',
                airName: selectedData.airName ?? null,
                airType: selectedData.airType ?? null,
                airSize: selectedData.airSize ?? null,
                remark1: selectedData.remark1 ?? '',
                createdBy: selectedData.createdBy?? null,
                createdAt: selectedData.createdAt?? null,
                updatedBy: auth.currentUser.displayName ?? null,
                updatedAt: serverTimestamp()?? null,
                deleted: false?? null,
                deletedAt: '',
                deletedBy: '',
                projectID: currentProjectID,
            }
        setFormData(updatedFormData);
        // console.log('Updated formData:', updatedFormData);
        }else{
            setFormData({
                masterID: masterID,
                uttID: uttID,
                capacity: "",
                connectionSize: "",
                airName:  "",
                airType: "",
                airSize: "",
                remark1: "",
                createdBy: auth.currentUser.displayName?? null,
                createdAt: serverTimestamp()?? null,
                updatedBy: auth.currentUser.displayName ?? null,
                updatedAt: serverTimestamp()?? null,
                deleted: false?? null,
                projectID: currentProjectID
        });
        }
    }, [mode, selectedData, masterID, onClose])

    useEffect(() => {
        // console.log('新しく書き込まれるformdata:', formData);
    }, [formData]);

    //日時編集
    useEffect(()=>{
        if(mode==="edit"&& selectedData?.createdAt){
            setCreatedAt(selectedData.createdAt);
        }
    },[mode, selectedData]);


    //新しいuttIDを生成(uttID+1になるように)
        useEffect(() => {
            if (mode==='create'){//editの時は動作しない
            const fetchUttID = async () => {
                try {
                    // Firestore クエリ: masterID に一致するデータを取得
                    const q = query(
                        collection(db, "03-1_airTable"),
                        where("masterID", "==", masterID),
                        where("projectID", "==", currentProjectID)
                    );
                    const querySnapshot = await getDocs(q);
                    // `uttID` の配列を取得
                    const uttIDs = querySnapshot.docs
                        .map(doc => doc.data().uttID)
                        .filter(id => id.startsWith("AR")) // (2) "AR"から始まるものを抽出
                        .map(id => parseInt(id.replace("AR", ""), 10)) // 数値部分を抽出し変換
                        .filter(num => !isNaN(num)); // 数値に変換できたものだけ残す

                    // 最大値を取得して +1
                    const nextNumber = uttIDs.length > 0 ? Math.max(...uttIDs) + 1 : 1;
                    const nextUttID = `AR${String(nextNumber).padStart(3, "0")}`; // 3桁フォーマット
                    setUttID(nextUttID); // `uttID` を更新
                    console.log('nextUTTIDを作りました。', mode, nextUttID, uttID)
                } catch (error) {
                    console.error("uttID の取得に失敗しました:", error);
                }
            };
               fetchUttID();
            }
        }, [isOpen, masterID]);

        useEffect(() => {
            const fetchOptions = async () => {
            try {
                const colRef = collection(
                db,
                `projects/${currentProjectID}/settings/air/airTypeOptions`
                );
                const querySnap = await getDocs(colRef);

                const supply = [];
                const exhaust = [];

                querySnap.forEach((docSnap) => {
                const data = docSnap.data();

                // isActive が true のものだけ処理
                if (data?.isActive === true) {
                    if (data?.type === "供給") {
                    supply.push(data.name);
                    } else if (data?.type === "排出") {
                    exhaust.push(data.name);
                    }
                }
                });

                setOptions({ supply, exhaust });
            } catch (error) {
                console.error("Firestore読み込みエラー:", error);
            }
            };

            fetchOptions();
        }, [currentProjectID]);


    // 変更時に入力値をformDataに反映する関数
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData, // 既存のデータを保持
            [name]: value // 変更されたフィールドだけ更新
        })
    );
    // console.log('変更されました。', formData);
    };
    
    //登録処理
    const handleSubmit = async (e) => {
    e.preventDefault(); // フォーム送信のデフォルト動作を防ぐ
    try {
        if (mode === 'edit') {
            // 🔹 Firestore から masterID に一致するデータを検索
            const q = query(
                collection(db, "03-1_airTable"),
                where("masterID", "==", masterID),
                where("uttID", "==", formData.uttID),
                where("projectID", "==", currentProjectID)
            );
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
        // ここから↓↓↓↓
                const docSnap = querySnapshot.docs[0];
                const docRef = docSnap.ref;
                const existingData = docSnap.data();

                // 🔹 更新データを作成
                const updatedFormData = { ...existingData, ...formData };
                await updateDoc(docRef, updatedFormData);

                // 🔹 フィールド単位で changeLogs に書き込み
                    // 除外するフィールド名の配列。以下のリストに記載されているフィールドは変更履歴に残らない。
                    const excludedFields = ["updatedAt", "createdAt"];
                    for (const key in updatedFormData) {
                        // 除外リストに含まれていればスキップ
                        if (excludedFields.includes(key)) continue;

                        if (updatedFormData[key] !== existingData[key]) { // 変更がある場合のみ
                            await logChange({
                                projectId: currentProjectID,
                                target: `03-1_airTable/${docRef.id}`,
                                field: key,
                                masterID: updatedFormData.masterID,
                                uttID: updatedFormData.uttID,
                                utilityType: '給排気',
                                oldValue: existingData[key],
                                newValue: updatedFormData[key],
                                userId: auth.currentUser.uid,
                                userName: auth.currentUser.displayName || "unknown",
                                timestamp: serverTimestamp()
                            });
                        }
                    }


                onClose();
            } else {
                console.error("エラー: 該当のドキュメントが存在しません");
            }

    // ここまで↑↑↑↑↑↑↑
        } else {
            // 新規作成モード (追加)
            const newRef = await addDoc(collection(db, "03-1_airTable"), formData);
            onClose();
        }
    } catch (error) {
        console.error("エラー:", error);
    }
};


    // フォームの入力ハンドラ。capacityAが変化したときにset
    const handleCapacityAChange = (e) => {
        setCapacityA(e.target.value);
    };

    const handleDelete = async () => {
        if (!selectedData || !selectedData.masterID || !selectedData.uttID) {
            alert("削除対象のデータが見つかりません。");
            return;
        }
        const confirmDelete = window.confirm("本当に削除しますか？");
        if (!confirmDelete) return;

        try {
            const q = query(
                collection(db, "03-1_airTable"),
                where("masterID", "==", selectedData.masterID),
                where("uttID", "==", selectedData.uttID),
                where("projectID", "==", currentProjectID)
            );

            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
                const docRef = querySnapshot.docs[0].ref;
                const existingData = querySnapshot.docs[0].data();

                // Firestore のデータを更新（論理削除）
                const updatedData = {
                    deleted: true,
                    deletedAt: serverTimestamp(),
                    deletedBy: auth.currentUser.displayName ?? "Unknown"
                };
                await updateDoc(docRef, updatedData);

                // 🔹 変更履歴ログをchangeLogsに作成
                await logChange({
                    projectId: currentProjectID,
                    target: `03-1_airTable/${docRef.id}`,
                    field: "deleted",
                    masterID: existingData.masterID,
                    uttID: existingData.uttID,
                    utilityType: '給排気',
                    oldValue: existingData.deleted ?? false,
                    newValue: true,
                    userId: auth.currentUser.uid,
                    userName: auth.currentUser.displayName || "unknown",
                    timestamp: serverTimestamp()
                });

                alert("削除が完了しました。");
                onClose();
            } else {
                alert("該当のデータが見つかりませんでした。");
            }
        } catch (error) {
            console.error("削除に失敗しました:", error);
            alert("削除に失敗しました。");
        }
    };


    if(!isOpen) {
        return null;//モーダルが開かれていないときは表示しない
    }
    return(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <button className="close-btn" onClick={onClose}>×</button>
                    <h2 class="title air">{mode==="edit"? "給排気 編集": "給排気 新規作成"}画面</h2>
                    {/* 編集時のみ削除ボタン表示 */}
                    {mode === "edit" && (
                        <button onClick={handleDelete} className="delete-btn">
                            <FontAwesomeIcon icon={faTrashAlt} size={40} />削除
                        </button>
                    )}
                </div>
                    <form id="form_air" onSubmit={handleSubmit}>
                        <div className="EditContainer">
                        <button type="submit"> "登録 / 更新"</button>
                            {/* <!-- col1 --> */}
                            <div class="inputContainer">
                                <label for="masterID">マスターID</label>
                                <input
                                    type="text"
                                    name="masterID"
                                    class="inputbox"
                                    disabled
                                    id="input1"
                                    value={formData.masterID}
                                    onChange={handleChange}
                                />
                                </div>
                                {/* <!-- col2 --> */}
                                <div class="inputContainer">
                                    <label for="ut_id">uttID</label>
                                    <input
                                    type="text"
                                    name="uttID"
                                    class="inputbox"
                                    disabled
                                    id="input2"
                                    onChange={handleChange}
                                    value ={mode==='edit'?selectedData.uttID: uttID}/>
                                    
                                </div>
                                {/* <!-- col3 --> */}
                                <div class="inputContainer">
                                    <label for="airName">名称</label>
                                    <input
                                    type="text"
                                    name="airName"
                                    class="inputbox"
                                    id="input3"
                                    required
                                    value={formData.airName}
                                    onChange={handleChange}/>
                                </div>
                                {/* <!-- col4 --> */}
                                <div class="inputContainer">
                                    <label for="airType_id">種類</label>
                                    <select
                                        name="airType"
                                        id="input4"
                                        className="inputbox"
                                        required
                                        value={formData.airType}
                                        onChange={(e) => handleChange(e)}
                                    >
                                    <option value="">選択してください</option>
                                    {options?.supply?.length > 0 && (
                                    <>
                                        <option value="">■ーーーーー供給ーーーーー■</option>
                                        {options.supply.map((opt, i) => (
                                        <option key={`supply-${i}`} value={opt}>
                                            {opt}
                                        </option>
                                        ))}
                                    </>
                                    )}

                                    {options?.exhaust?.length > 0 && (
                                    <>
                                        <option value="">■ーーーーー排出ーーーーー■</option>
                                        {options.exhaust.map((opt, i) => (
                                        <option key={`exhaust-${i}`} value={opt}>
                                            {opt}
                                        </option>
                                        ))}
                                    </>
                                    )}
                                    </select>
                                </div>
                                {/* <!-- col5 --> */}
                                <div class="inputContainer">
                                    <label for="capacity">必要流量[L/min]</label>
                                    <input
                                    type="number"
                                    min="1"
                                    step="1"
                                    name="capacity"
                                    class="inputbox"
                                    id="input5"
                                    value={formData.capacity}
                                    onChange={(e)=>{
                                        handleChange(e);
                                    }}/>
                                </div>
                                {/* <!-- col6 --> */}
                                <div class="inputContainer">
                                    <label for="connectionSize">配管口径(A呼称/B呼称)</label>
                                    <select 
                                    type="number"
                                    name="connectionSize"
                                    class="inputbox"
                                    id="input6"
                                    onChange={handleChange}
                                    value={formData.connectionSize}
                                    >
                                    <option value=""></option>
                                        <option value="25A / 1S">25A / 1S</option>
                                        <option value="32A / 1 1/4S">32A / 1 1/4S</option>
                                        <option value="40A / 1 1/2S">40A / 1 1/2S</option>
                                        <option value="50A / 2S">50A / 2S</option>
                                        <option value="65A / 2 1/2S">65A / 2 1/2S</option>
                                        <option value="80A / 3S">80A / 3S</option>
                                        <option value="90A /3 1/2S">90A /3 1/2S</option>
                                        <option value="100A / 4S">100A / 4S</option>
                                        <option value="標準外寸法">標準外寸法</option>
                                    </select>
                                </div>
                            </div>
                            <div class="inputContainer remark1">
                                <label for="remark1">備考</label>
                                <textarea name="remark1" id="input8" placeholder="備考等を入力ください。" class="inputbox"
                                value={formData.remark1}
                                onChange={handleChange}></textarea>
                            </div>
                    </form>
            </div>
        </div>    );
};

export default ModalAir;